import React, { useContext, useEffect, useState } from "react";

import { GlobalContext } from "@/contexts";
import {
  QuestionInteractionOutro,
  QuestionOrAdvertisingOutro,
} from "@/service/Model";
import {
  QuestionConfigData,
  QuestionSet,
  TealiumAgeRange,
  TealiumGender,
  TealiumIncomeRange,
} from "@/service/Tealium";
import TrackingService from "@/service/Tracking";
import Svg from "@/styles/Svg";
import { Enum } from "@/utils/transform";

import { OutroPropsExtented } from "../index";
import { OutroFeedback, OutroFeedbackIcon } from "../styles";
import { QuestionFieldset, QuestionOption, QuestionTitle } from "./styles";
interface QuestionProps extends OutroPropsExtented {
  outro: QuestionInteractionOutro | QuestionOrAdvertisingOutro;
}
const Question: React.FC<QuestionProps> = (
  props: QuestionProps
): JSX.Element => {
  const [voted, setVoted] = useState(false);
  const { genderRequest, ageRequest, incomeRequest } = props.outro;
  const globalContext = useContext(GlobalContext);
  const { tealiumConfig, icons } = globalContext;

  useEffect(() => {
    TrackingService.getInstance().trackOnOutroImpression();
  }, []);

  const handleOptionClick = (value: string) => {
    if (genderRequest && Enum.contains(TealiumGender, value)) {
      globalContext.sendTealiumProfile({ gender: value });
    } else if (ageRequest && Enum.contains(TealiumAgeRange, value)) {
      globalContext.sendTealiumProfile({ age_range: value });
    } else if (incomeRequest && Enum.contains(TealiumIncomeRange, value)) {
      globalContext.sendTealiumProfile({ income_range: value });
    } else {
      return;
    }

    setVoted(true);
    TrackingService.getInstance().trackOnOutroClick();
  };

  const renderRequest = (questionSet: QuestionSet): JSX.Element => {
    const htmlOptions = questionSet.options.map((option: any, i: number) => (
      <QuestionOption key={i} onClick={() => handleOptionClick(option.value)}>
        {option.text}
      </QuestionOption>
    ));

    return (
      <div data-qa={"question"}>
        <QuestionTitle>{questionSet.question}</QuestionTitle>
        <QuestionFieldset>{htmlOptions}</QuestionFieldset>
      </div>
    );
  };

  const renderThankYou = (): JSX.Element => {
    return (
      <OutroFeedback>
        <OutroFeedbackIcon success={true}>
          <Svg contents={icons.Success} height={65} width={65} />
        </OutroFeedbackIcon>
        <h3>VIELEN DANK FÜR IHRE TEILNAHME</h3>
      </OutroFeedback>
    );
  };

  if (!tealiumConfig) {
    return <></>;
  }

  if (voted) {
    return <div>{renderThankYou()}</div>;
  }

  if (genderRequest && !tealiumConfig.gender) {
    return <div>{renderRequest(QuestionConfigData.gender)}</div>;
  } else if (ageRequest && !tealiumConfig.age_range) {
    return <div>{renderRequest(QuestionConfigData.age_range)}</div>;
  } else if (incomeRequest && !tealiumConfig.income_range) {
    return <div>{renderRequest(QuestionConfigData.income_range)}</div>;
  } else {
    // demographic data is completed in tealiumConfig
    return <React.Fragment />;
  }
};

export default Question;
